export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14619.65beb38b.jpg";